import { render, staticRenderFns } from "./categorylist.vue?vue&type=template&id=6f4471fc&"
import script from "./categorylist.vue?vue&type=script&lang=ts&"
export * from "./categorylist.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\Thermotech\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f4471fc')) {
      api.createRecord('6f4471fc', component.options)
    } else {
      api.reload('6f4471fc', component.options)
    }
    module.hot.accept("./categorylist.vue?vue&type=template&id=6f4471fc&", function () {
      api.rerender('6f4471fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Dev/js/components/products/categorylist.vue"
export default component.exports